(function () {
  'use strict';

  var desktopQuery = window.matchMedia('(min-width: 992px)');
  var productPath = '/products/jill-leen-colorful-soft-mist-blush-3g-matte-pearlescent-face-cheek-brightening-makeup-for-20-30';
  var productImageToken = '790__21_cf7ca4d0-6d5d-49b5-8800-1a31c047c552';
  var active = false;

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);
    element.className = className;
    element.setAttribute('data-jillleen-pdp-created', 'true');
    if (text) element.textContent = text;
    return element;
  }

  function createProductVisual() {
    if (window.location.pathname !== productPath) return;

    var photoContainer = document.querySelector('.product-photo-container');
    var gallery = document.querySelector('.product-img-box') || (photoContainer ? photoContainer.parentElement : null);
    if (!gallery || gallery.querySelector('.jillleen-pdp-product-visual')) return;

    var source = Array.prototype.find.call(gallery.querySelectorAll('img'), function (image) {
      return (image.currentSrc || image.src || '').indexOf(productImageToken) !== -1;
    });
    if (!source) return;

    var originalChildren = Array.prototype.slice.call(gallery.children);
    originalChildren.forEach(function (child) {
      child.classList.add('jillleen-pdp-original-gallery');
    });

    gallery.classList.add('jillleen-pdp-gallery-host');

    var figure = createElement('figure', 'jillleen-pdp-product-visual');
    var image = createElement('img', 'jillleen-pdp-product-visual__image');
    image.src = source.currentSrc || source.src;
    image.alt = 'JILL LEEN Colorful Soft Mist Blush compacts';
    image.loading = 'eager';
    image.decoding = 'async';
    image.setAttribute('fetchpriority', 'high');
    figure.appendChild(image);
    gallery.insertBefore(figure, gallery.firstChild);
    document.body.classList.add('jillleen-pdp-product-only-ready');
  }

  function createPurchaseIntro() {
    var shop = document.querySelector('.product-shop');
    if (!shop || shop.querySelector('.jillleen-pdp-title')) return;

    var originalTitle = shop.querySelector('.group-title');
    var prices = shop.querySelector('.prices');
    if (!originalTitle || !prices) return;

    var eyebrow = createElement('p', 'jillleen-pdp-eyebrow', 'Powder blusher');
    var title = createElement('h1', 'jillleen-pdp-title', 'Colorful Soft Mist Blush');
    var benefit = createElement(
      'p',
      'jillleen-pdp-benefit',
      'A compact blush available in matte and pearlescent finishes.'
    );

    shop.insertBefore(eyebrow, originalTitle);
    shop.insertBefore(title, originalTitle);
    prices.insertAdjacentElement('afterend', benefit);
  }

  function createShadeToggle() {
    var swatch = document.querySelector('.product-shop .swatch');
    if (!swatch || swatch.querySelector('.jillleen-pdp-shade-toggle')) return;

    var shadeCount = swatch.querySelectorAll('.swatch-element').length;
    if (shadeCount <= 8) return;

    swatch.classList.add('jillleen-swatches-collapsed');
    var button = createElement('button', 'jillleen-pdp-shade-toggle', 'View all ' + shadeCount + ' shades');
    button.type = 'button';
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', function () {
      var collapsed = swatch.classList.toggle('jillleen-swatches-collapsed');
      button.setAttribute('aria-expanded', String(!collapsed));
      button.textContent = collapsed ? 'View all ' + shadeCount + ' shades' : 'Show fewer shades';
    });
    swatch.appendChild(button);
  }

  function createCheckoutNote() {
    var groups = document.querySelector('.product-shop .groups-btn');
    if (!groups || groups.querySelector('.jillleen-pdp-checkout-note')) return;

    var note = createElement(
      'p',
      'jillleen-pdp-checkout-note',
      'Shipping, taxes, and discounts are shown before checkout.'
    );
    var terms = groups.querySelector('.checkbox-group');
    if (terms) groups.insertBefore(note, terms);
    else groups.appendChild(note);
  }

  function hideQuestionPrompt() {
    Array.prototype.forEach.call(document.querySelectorAll('a, button'), function (element) {
      if (/Ask An Expert|Have Questions/i.test(element.textContent || '')) {
        element.classList.add('jillleen-pdp-question');
      }
    });
  }

  function activate() {
    if (active || !desktopQuery.matches || !document.body.classList.contains('template-product')) return;
    active = true;
    document.body.classList.add('jillleen-pdp-minimal-ready');
    createProductVisual();
    createPurchaseIntro();
    createShadeToggle();
    createCheckoutNote();
    hideQuestionPrompt();
  }

  function deactivate() {
    if (!active) return;
    active = false;

    document.querySelectorAll('[data-jillleen-pdp-created="true"]').forEach(function (element) {
      element.remove();
    });
    document.querySelectorAll('.jillleen-pdp-original-gallery').forEach(function (element) {
      element.classList.remove('jillleen-pdp-original-gallery');
    });
    document.querySelectorAll('.jillleen-pdp-gallery-host').forEach(function (element) {
      element.classList.remove('jillleen-pdp-gallery-host');
    });
    document.querySelectorAll('.jillleen-swatches-collapsed').forEach(function (element) {
      element.classList.remove('jillleen-swatches-collapsed');
    });
    document.querySelectorAll('.jillleen-pdp-question').forEach(function (element) {
      element.classList.remove('jillleen-pdp-question');
    });
    document.body.classList.remove('jillleen-pdp-product-only-ready');
    document.body.classList.remove('jillleen-pdp-minimal-ready');
  }

  function handleBreakpoint(event) {
    if (event.matches) activate();
    else deactivate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activate, { once: true });
  } else {
    activate();
  }

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', handleBreakpoint);
  } else {
    desktopQuery.addListener(handleBreakpoint);
  }
})();
